export const prefix = "bat"
export const iconName = "sort"
export const width = 7
export const height = 11
export const ligatures = []
export const unicode = ""
export const svgPathData =
    "M0.128693 3.70754L2.91117 0.240371C3.15882 -0.0801236 3.56672 -0.0801236 3.81438 0.240371L6.59685 3.70754C6.84451 4.02803 6.72796 4.29026 6.30549 4.29026H0.420052C-0.00241824 4.29026 -0.118962 4.02803 0.128693 3.70754ZM6.59685 7.29246L3.81438 10.7596C3.56672 11.0801 3.15882 11.0801 2.91117 10.7596L0.128693 7.29246C-0.118962 6.97197 -0.00241824 6.70974 0.420052 6.70974H6.30549C6.72796 6.70974 6.84451 6.97197 6.59685 7.29246Z"

export const definition = {
    prefix,
    iconName,
    icon: [width, height, ligatures, unicode, svgPathData],
}

export const batSort = definition
